import { View } from '@react-pdf/renderer';
import { IInfoTableRow } from 'PDF/helpers/pdfMapping';
import { globalStyles } from 'PDF/styles';

import { InfoTableRow } from '../InfoTableWithIcons/InfoTableRow';
import { SmallHeading } from '../SmallHeading';

interface IInfoTableProps {
  rows: IInfoTableRow[][];
  heading?: string;
  titleTextWeight?: number;
}

export const InfoTable = ({ rows, heading, titleTextWeight }: IInfoTableProps) => {
  const filteredRows = rows
    .map((row) =>
      row.filter(({ info }) => (Array.isArray(info) ? info.length : typeof info === 'object' ? info?.imgSrc : info)),
    )
    .filter((array) => array.length);

  if (!filteredRows.length) {
    return null;
  }
  const [firstRow, ...restRows] = filteredRows;

  return (
    <>
      <View wrap={false}>
        {heading && <SmallHeading heading={heading} />}
        <View style={globalStyles.marginBottom}>
          {firstRow.map((item, index) => (
            <InfoTableRow key={item.id} data={item} isFirst={index === 0} titleTextWeight={titleTextWeight} />
          ))}
        </View>
      </View>
      {restRows.map((row: IInfoTableRow[], rowIndex?: number) => {
        return (
          <View key={rowIndex} style={globalStyles.marginBottom}>
            {row.map((item, index) => (
              <InfoTableRow key={item.id} data={item} isFirst={index === 0} titleTextWeight={titleTextWeight} />
            ))}
          </View>
        );
      })}
    </>
  );
};
